import { Component } from "react"
import PropTypes from "prop-types"
import { Button, Tooltip } from "@mui/material"

import "./style.scss"

class Profile extends Component {
  constructor(props, ...args) {
    super(props, ...args)

    const { name, email } = props
    this.state = {
      name,
      email,
    }
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    profileErrors: PropTypes.arrayOf(PropTypes.string).isRequired,
    update: PropTypes.func.isRequired,
  }

  onChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  onSave = () => {
    const { update } = this.props

    update("profile", "/api/users/me", this.state, {
      onSuccess: "Profile updated",
    })
  }

  render() {
    const { profileErrors } = this.props

    const { name, email } = this.state
    return <div>
      {!!profileErrors.length && <div className="alert alert-danger pl-5">
        {profileErrors.map((error, i) => <div key={i}>{error}</div>)}
      </div>}
      <div className="form-group">
        <label htmlFor="name">Full name</label>
        <input
          className="form-control"
          type="text"
          id="name"
          name="name"
          value={name}
          onChange={this.onChange}
        />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email address</label>
        <Tooltip
          classes={{
            popper: "user-profile-tooltip",
            tooltip: "user-profile-tooltip",
          }}
          title={"For security purposes, this email cannot be changed. If you would like to update your email, please reach out to your account admin or Omega Point's customer success team."}
        >
          <input
            disabled
            className="form-control"
            type="text"
            id="email"
            name="email"
            value={email}
          />
        </Tooltip>
      </div>
      <Button variant="contained" color="primary" className="pull-right" onClick={this.onSave}>Save</Button>
    </div>
  }
}

export default Profile
